
app.controller('OTPController', ['$rootScope', '$scope', '$routeParams', '$http', '$window', '$q', 'appFactory', '$timeout', '$sce', '$uibModalInstance', '$compile', 'items',
function ($rootScope, $scope, $routeParams, $http, $window, $q, appFactory, $timeout, $sce, $uibModalInstance, $compile, items) {
    $scope.inputs = ['', '', '', '']; // Initialize inputs array
    $scope.buttonDisabled = true; // Disable button initially
    $scope.textAlert = false; // Disable text alert if not verify
    $scope.email = items;
    $scope.OTP = {}

    $timeout(function () {
        angular.element('.otp-field > input')[0].focus();
    });

    //angular.element('.btn').attr('disabled', 'disabled');

    $scope.focusInput = function (event, index) {
        if ($scope.inputs[index] === "") {
            event.target.value = ""; // Clear input if it's not a number
        }
    };

    $scope.handleKeyUp = function (event, index) {
        const key = event.key.toLowerCase();
        if (key === "backspace") {
            if (index > 0) {
                $scope.inputs[index - 1] = "";
                angular.element('.otp-field > input')[index - 1].focus();
            }
            return;
        }

        if ($scope.inputs[index].length > 1) {
            $scope.inputs[index] = "";
            return;
        }

        const nextIndex = index + 1;
        if (nextIndex < $scope.inputs.length && $scope.inputs[index] !== "") {
            $scope.inputs[nextIndex] = "";
            angular.element('.otp-field > input')[nextIndex].focus();
        }

        $scope.updateButtonState();
    };

    $scope.updateButtonState = function () {
        $scope.buttonDisabled = $scope.inputs.some(input => input === "");
    };

    $scope.text = 'Initial Text';
    $scope.countdown = 30; // 5 minutes in seconds

    // Function to update the text and countdown timer
    var updateTextAndCountdown = function () {
        $scope.countdown--; // Decrement the countdown timer
        if ($scope.countdown <= 0) {
            $scope.text = $sce.trustAsHtml('<a style="color:#E6A900;" ng-click="getOTP()">Kirim ulang kode</a>'); // Change the text when countdown reaches 0

            // Use $timeout to ensure the HTML is rendered before compiling
            $timeout(function () {
                var container = angular.element(document.getElementById('textContainer'));
                $compile(container.contents())($scope);
            }, 0);
        } else {
            // Update the countdown timer text
            var minutes = Math.floor($scope.countdown / 60);
            var seconds = $scope.countdown % 60;
            $scope.text = $sce.trustAsHtml('Kirim ulang kode dalam ' + minutes + ' : ' + seconds + ' ');

            // Schedule the next update after 1 second
            $timeout(updateTextAndCountdown, 1000);
        }
    };

    $scope.getOTP = function () {
        $scope.countdown = 180; // 3 minutes in seconds
        updateTextAndCountdown();
        appFactory.getData(`/service/client.svc/APIOTP?Email=${$scope.email}`).then(function (data) {

            if (data.status == 200) {

                if (data.data.d != true) {
                    var obj = data.data.d;
                }
            }
        });
    }

    // Start the countdown timer
    updateTextAndCountdown();

    var allPromise = $q.all([
        $scope.getOTP()

    ]);

    allPromise.then(function () {

    });


    $scope.submit = function () {
        var strOTP = $scope.inputs.join('');

        $scope.OTP.Email = $scope.email;
        $scope.OTP.KodeOTP = strOTP;

        return $http({
            method: "POST",
            url: '/service/client.svc/ValidateOTP',
            data: { OTP: $scope.OTP }
        }).then(data => {

            console.log(data.data.d.result)

            if (data.data.d.result) {

                console.log('VERIFIED');
                //swal('success', 'Verifikasi OTP telah berhasil', 'success').then(function () {
                    //$uibModalInstance.close("VERIFIED");
                //});

                appFactory.postGetData(
                    `/service/client.svc/LoginUser`,
                    'POST',
                    { UserLogin: $rootScope.objUser }
                ).then(function (data) {

                    if (data.status == 200) {

                        $scope.result = data.data.d;

                        // login ok
                        if ($scope.result.result) {
                            $rootScope.pageLogin = false;
                            console.log($scope.result)

                            $window.location.href = "#/cif/data-pribadi";
                            $window.location.reload();
                            return;
                        }
                    }
                });
                $uibModalInstance.close("VERIFIED");
                return;
            } else {

                console.log('not verified');
                $scope.textAlert = true;
                return;
            }

            callback(data.data.d.result); // send /return callback to .js
        })
            .catch(error => {
                swal.fire(
                    "There is a problem connecting to the server. \
                    Please ensure your internet connection is active. If the problem persists, please try again later."
                )
                console.log(`Request failed: ${error}`)
            })

        //if (strOTP == 1234) {
        //    console.log('VERIFIED');
        //    $uibModalInstance.close("VERIFIED");
        //} else {
        //    console.log('not verified');
        //    $scope.textAlert = true;
        //}

    }
}]);